import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Link,
} from '@mui/material';
import Config from '../../../config';

const PERMISSION_MAPPINGS = [
  { internal: 'users/manage', display: 'User Management' },
  { internal: 'orders/manage', display: 'Order Management' },
  { internal: 'inventory/manage', display: 'Inventory & Product Management' },
  { internal: 'api/manage', display: 'API/Webhook Management' },
  { internal: 'settings/manage', display: 'Settings Management' },
  { internal: 'ccn/manage', display: 'Connected Commerce Network Access' },
  { internal: 'analytics/manage', display: 'Advanced Reporting Access' },
  { internal: 'integrations/manage', display: 'Onboarding Management' },
];

interface PermissionsHelperDialogProps {
  open: boolean;
  onClose: () => void;
}

const PermissionsHelperDialog: React.FC<PermissionsHelperDialogProps> = ({ open, onClose }) => {
  const manageUsersUrl = Config.production
    ? 'https://portal.logicbroker.com/settings/users'
    : 'https://stage-portal.logicbroker.com/settings/users';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth sx={{ '& .MuiDialogContent-root': { overflowX: 'hidden' } }}>
      <DialogTitle>Available Permissions</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          Use the internal names below (separated by semicolons) in the Permissions column of your CSV.
          See the <Link href={manageUsersUrl} target="_blank" rel="noopener noreferrer">Manage Users page</Link> for
          detailed permission descriptions.
        </Typography>
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell><strong>Internal Name (use in CSV)</strong></TableCell>
                <TableCell><strong>Display Name</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {PERMISSION_MAPPINGS.map((perm) => (
                <TableRow key={perm.internal}>
                  <TableCell><code>{perm.internal}</code></TableCell>
                  <TableCell>{perm.display}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PermissionsHelperDialog;
